import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';

export default class ApprovalConfigurationInstanceFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.name = '';
		this.approvalInstance = '';
		this.approvalTypeId  = '';
		this.approvalTypeName = '';
		this.descriptionMultiple = '';
		this.appliedToId  = '';
		this.appliedToName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			name : '0',
			approvalInstance : '0',
			approvalTypeId : '0',
			approvalTypeName : '0',
			descriptionMultiple : '0',
			appliedToId : '0',
			appliedToName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}